<template>
<div class="container">
  <div class="wrapper">
    <router-link tag="div" class="title sticky btn btn-primary" :to="{name: 'SingleRoomTimetableView', params: {roomId: room.id, date: date} }">{{room.name}}</router-link>
    <div class="timetable-wrap">
      <TimeTable class="timetable" :bookings="getBookingsByRoom(date, roomId)" :date="date" :roomId="roomId"></TimeTable>
    </div>
  </div>
</div>
</template>

<script>

import { mapGetters } from 'vuex';

import TimeTable from '@/components/TimeTable'

import Booking from './../store/modules/booking/types'
import Room from './../store/modules/room/types'

export default {
  name: 'RoomSelectWithTimetable',
  props: ['date', 'roomId'],
  components: { TimeTable },
  computed: {
    room () {
      return this.getRoomById(this.roomId);
    },
    ...mapGetters('Booking', [Booking.getters.GET_BOOKINGS_BY_ROOM]),
    ...mapGetters('Room', [Room.getters.GET_ROOM_BY_ID])
  }
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';
@import 'src/values.scss';

.title {
  border: $border-width solid $primary-dark;
  //border-bottom-right-radius: initial;
  //border-bottom-left-radius: initial;
  padding: 0.5em 0.2em;
  top: 2.5em;
  z-index: 99;
  transition: $transition-time all;
  &:hover {
    background-color: $secondary-dark;
  }
}

.container {
  box-sizing: border-box;
  padding: 0 0.5em;
}

.timetable-wrap {
  // padding: 0 1em;
  margin-top: 1px;
  //border: 1px solid $primary-dark;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomSelectWithTimetable.vue